/**
 *  @class
 *  @function HeaderPredictiveSearch
 */
class HeaderPredictiveSearch {
  constructor() {
    this.wrapper = document.querySelector('.header-search-wrapper');
    if (!this.wrapper) {
      console.log('Header search wrapper not found');
      return;
    }

    this.form = this.wrapper.querySelector('form.header-searchform');
    this.input = this.wrapper.querySelector('input[type="search"]');
    this.results = this.wrapper.querySelector('.header-search-results');

    if (!this.results) {
      console.error('Header search results container not found!');
      return;
    }

    console.log('Header search initialized', this.wrapper, this.input, this.results);

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));

    // Close results when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.wrapper.contains(event.target)) {
        this.close();
      }
    });

    // Close results on ESC key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    console.log('Search term:', searchTerm);

    if (!searchTerm.length) {
      this.close();
      return;
    }

    if (!this.results) {
      console.error('Results container not available');
      return;
    }

    this.results.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length || !this.results) {
      return;
    }

    if (this.results.innerHTML.trim()) {
      this.results.classList.add('active');
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    if (!this.results) return;
    
    this.results.classList.add('loading');

    // Check if theme routes exist
    if (typeof theme === 'undefined' || !theme.routes || !theme.routes.predictive_search_url) {
      console.error('Theme routes not found. Trying alternative...');
      // Use alternative URL construction
      const searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article,query&resources[limit]=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`;
      this.fetchResults(searchUrl);
      return;
    }

    const searchUrl = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`;
    
    console.log('Fetching from:', searchUrl);
    this.fetchResults(searchUrl);
  }

  fetchResults(url) {
    fetch(url)
      .then((response) => {
        console.log('Response received:', response);
        if (this.results) {
          this.results.classList.remove('loading');
        }
        if (!response.ok) {
          console.error('Response not OK:', response.status);
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        console.log('Response text length:', text.length);
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        
        if (!section) {
          console.error('Predictive search section not found in response');
          console.log('Response HTML:', text.substring(0, 500));
          return;
        }

        const resultsMarkup = section.innerHTML;
        console.log('Results markup length:', resultsMarkup.length);

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (this.results) {
          this.results.classList.remove('loading');
          this.results.innerHTML = '<div style="padding: 20px; text-align: center;">Error loading results</div>';
          this.results.classList.add('active');
        }
        console.error('Search error:', error);
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.results) return;
    
    this.results.innerHTML = resultsMarkup;
    this.results.classList.add('active');

    console.log('Results rendered');

    let _this = this;
    const submitButton = this.results.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }

    // Add click handlers for result links to close the dropdown
    const resultLinks = this.results.querySelectorAll('a');
    resultLinks.forEach(link => {
      link.addEventListener('click', () => {
        _this.close();
      });
    });
  }

  close() {
    if (this.results) {
      this.results.classList.remove('active');
    }
  }
}

// Helper function: debounce
if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return function() {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderSearch);
} else {
  initHeaderSearch();
}

function initHeaderSearch() {
  if (typeof HeaderPredictiveSearch !== 'undefined') {
    new HeaderPredictiveSearch();
  }
}